export default __webpack_public_path__ + "static/media/developer_portal.586b7bcf.svg";